import React from "react";
import "./Styles/recentProducts.css";
import Stroke from "../Images/Icones/Stroke.svg";
import rectangle from "../Images/Icones/Rectangle.svg";
import Carousel from 'better-react-carousel';
import BasicCard from './BasicCard';
import RecProCard from "./RecProCard";


export const RecPro = ({recentProducts}) => {
    const goToStore = () => {
        window.location.href = '/boutique'
    }

    return (
        <>
            <div className="RecentProducts-carousel">
                {
                    recentProducts.map((x, index)=>{
                        return (
                            <RecProCard product={x} />
                        )
                    })
                }
            </div>
        </>
    )
}